import { useEffect } from 'react'
import { useRouter } from 'next/router'

export const useScrollToTop = () => {
  const router = useRouter()

  useEffect(() => {
    const handleRouteChange = () => {
      window.scrollTo(0, 0)
      document.body.scrollTop = 0
    }
    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events])
}
